import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  {
    street0: {
      marginBottom: "-6px"
    },
    street1: {
      marginTop: "-14px"
    },
    taxNumber: {
      width: "235px"
    },
    mobileFax: {
      marginRight: "-11px"
    },
    taxNumberOtc: {
      width: "252px"
    }
  },
  { name: "useOneTimeForm" }
);

export default useStyles;
